// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"49681afdf744e5bb","6831":"a119672cb3e77c53","8503":"118052b2dda4354e","9683":"2578832a75afb14c"}[chunkId] + ".js";
};